import { removeQueryString } from "@finway-group/shared/lib/utils"
import axios, { AxiosHeaders } from "axios"
import React, { useEffect, useState } from "react"
import { Loading } from "~Components/loading"
import { FileViewer, FileViewerProps } from "./FileViewer"

const axiosInstance = axios.create({ headers: new AxiosHeaders(), baseURL: undefined, withCredentials: false })

export const FileViewerCached = (props: FileViewerProps) => {
    const [{ url, cachePath, isCached }, setFileData] = useState({ url: "", cachePath: "", isCached: false })

    useEffect(() => {
        const { filePath } = props
        if (!filePath) {
            return
        }
        const isCachedAlready = isCached && cachePath && filePath && removeQueryString(cachePath) === removeQueryString(filePath)
        if (isCachedAlready) {
            return
        }

        const axiosRequestAbortController = new AbortController()
        axiosInstance
            .get(filePath, { responseType: "blob", signal: axiosRequestAbortController.signal })
            .then(({ data }) => {
                setFileData({ url: URL.createObjectURL(data), cachePath: filePath, isCached: true })
            })
            .catch(() => {
                // Fallback: render file w/o caching
                setFileData({ url: filePath, cachePath: filePath, isCached: false })
            })
        return () => {
            axiosRequestAbortController.abort()
            // Release memory if needed
            if (url) {
                URL.revokeObjectURL(url)
            }
        }
    }, [props.filePath])

    if (!props.filePath) {
        return null
    }
    if (!url) {
        return <Loading />
    }
    return <FileViewer {...{ ...props, filePath: url }} />
}
